import Marquee from "react-fast-marquee";

export const EditorialMarquee = ({ items, speed = 40, className = "" }) => {
  return (
    <div className={`border-y border-white/10 py-5 md:py-7 bg-black overflow-hidden ${className}`} data-testid="editorial-marquee">
      <Marquee speed={speed} gradient={false} autoFill>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display uppercase text-4xl md:text-6xl tracking-tight mx-8 md:mx-12 text-white">
              {item}
            </span>
            <span className="text-[#E30613] text-4xl md:text-6xl">✳</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
